"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchVerifyOtpLogin = void 0;
const fetchVerifyOtpLogin = (api, progressId, body, url) => api.POST(url, body, {
    headers: {
        progressId,
    },
});
exports.fetchVerifyOtpLogin = fetchVerifyOtpLogin;
//# sourceMappingURL=resolver.js.map